import { useThreadHeaderContext } from '@frontend/thread-header-context';
import { PersonPhoneSelectorProps, PersonPhoneSelector, PersonPhoneSelectorState } from './person-phone-selector';
import { usePersonPhoneSelector } from './use-person-phone-selector';

type Props = Omit<
  PersonPhoneSelectorProps,
  keyof PersonPhoneSelectorState | 'onSelectPersonPhone' | 'allowCustomPhoneNumber' | 'locationId' | 'variant'
>;

export const PersonPhoneSelectorAtom = (rest: Props) => {
  const {
    groupId,
    personPhone,
    primaryContactId,
    primaryContact,
    contextPersonId,
    contextContact,
    onPersonPhoneChange,
    allowCustomPhoneNumber,
    variant,
  } = useThreadHeaderContext();

  const personPhoneSelectorState = usePersonPhoneSelector({
    groupId,
    personPhone,
    allowCustomPhoneNumber,
    personId: contextContact?.personId || contextPersonId || primaryContact?.personId || primaryContactId || '',
    person: contextContact || primaryContact,
  });

  if (!onPersonPhoneChange) return null;

  return (
    <PersonPhoneSelector
      {...personPhoneSelectorState}
      onSelectPersonPhone={onPersonPhoneChange}
      allowCustomPhoneNumber={allowCustomPhoneNumber}
      locationId={groupId}
      variant={variant}
      {...rest}
    />
  );
};
